import { mergeAttributes, Node, ReactNodeViewRenderer } from '@tiptap/react';

import { genRandId } from 'shared/common/utils/core.utils';

import { AudioNode } from './components/AudioNode';
import { AUDIO_NODE_NAME, AUDIO_TAG } from './consts';

export type SetAudioOptions = {
  alt: string;
  src: string;
};

declare module '@tiptap/react' {
  interface Commands<ReturnType> {
    audio: {
      setAudio: (options: SetAudioOptions) => ReturnType;
    };
  }
}

// Attributes must stay non-null strings: `buildXmlNode` in `staticContentToYDoc` drops null-valued
// attributes, breaking the serialize → deserialize → serialize round-trip.
export const Audio = Node.create({
  name: AUDIO_NODE_NAME,

  inline: true,
  group: 'inline',
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      audioId: {
        default: '',
        parseHTML: element => element.getAttribute('data-audio-id') ?? '',
        renderHTML: attributes => ({ 'data-audio-id': attributes.audioId })
      },
      src: {
        default: '',
        parseHTML: element => element.getAttribute('src') ?? '',
        renderHTML: attributes => ({ src: attributes.src })
      },
      alt: {
        default: '',
        parseHTML: element => element.getAttribute('alt') ?? '',
        renderHTML: attributes => ({ alt: attributes.alt })
      }
    };
  },

  parseHTML() {
    return [{ tag: AUDIO_TAG }];
  },

  renderHTML({ HTMLAttributes }) {
    return [AUDIO_TAG, mergeAttributes(HTMLAttributes)];
  },

  addCommands() {
    return {
      setAudio:
        options =>
        ({ commands }) =>
          commands.insertContent({ type: this.name, attrs: { ...options, audioId: genRandId() } })
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(AudioNode);
  }
});
